/* tslint:disable */
/* eslint-disable */
/**
 * Accounts API
 * API pour la gestion des comptes utilisateurs
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePasswordCommand
 */
export interface UpdatePasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordCommand
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordCommand
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordCommand
     */
    confirmNewPassword: string;
}

/**
 * Check if a given object implements the UpdatePasswordCommand interface.
 */
export function instanceOfUpdatePasswordCommand(value: object): value is UpdatePasswordCommand {
    if (!('currentPassword' in value) || value['currentPassword'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    if (!('confirmNewPassword' in value) || value['confirmNewPassword'] === undefined) return false;
    return true;
}

export function UpdatePasswordCommandFromJSON(json: any): UpdatePasswordCommand {
    return UpdatePasswordCommandFromJSONTyped(json, false);
}

export function UpdatePasswordCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePasswordCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPassword': json['currentPassword'],
        'newPassword': json['newPassword'],
        'confirmNewPassword': json['confirmNewPassword'],
    };
}

export function UpdatePasswordCommandToJSON(json: any): UpdatePasswordCommand {
    return UpdatePasswordCommandToJSONTyped(json, false);
}

export function UpdatePasswordCommandToJSONTyped(value?: UpdatePasswordCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPassword': value['currentPassword'],
        'newPassword': value['newPassword'],
        'confirmNewPassword': value['confirmNewPassword'],
    };
}

